<script setup lang="ts">
import { computed } from 'vue';
import { useToast } from '@/composables/useToast';

const { toasts, dismiss } = useToast();

const kindClasses = computed(() => (kind: string) => {
    switch (kind) {
        case 'success':
            return 'border-gold-deep bg-gold/10 text-burgundy';
        case 'error':
            return 'border-burgundy bg-burgundy text-cream';
        default:
            return 'border-line bg-cream text-ink';
    }
});

const iconFor = (kind: string) => {
    if (kind === 'success') return 'fa-circle-check';
    if (kind === 'error') return 'fa-circle-exclamation';
    return 'fa-circle-info';
};
</script>

<template>
    <Teleport to="body">
        <div class="pointer-events-none fixed inset-x-0 top-3 z-50 flex flex-col items-center gap-2 px-4">
            <TransitionGroup name="toast">
                <div
                    v-for="t in toasts"
                    :key="t.id"
                    class="pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-lg border px-4 py-3 shadow-lg"
                    :class="kindClasses(t.kind)"
                    role="alert"
                >
                    <i class="fa-solid mt-0.5" :class="iconFor(t.kind)" aria-hidden="true"></i>
                    <p class="flex-1 font-body text-sm">{{ t.message }}</p>
                    <button
                        type="button"
                        class="font-body text-xs opacity-70 hover:opacity-100"
                        @click="dismiss(t.id)"
                        aria-label="Fechar"
                    >
                        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                    </button>
                </div>
            </TransitionGroup>
        </div>
    </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
    transition: all 0.2s ease;
}
.toast-enter-from {
    opacity: 0;
    transform: translateY(-8px);
}
.toast-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}
</style>
